import { render } from "./FORUM_CANDIDATE_VAL_NEW.vue?vue&type=template&id=5b402192"
import script from "./FORUM_CANDIDATE_VAL_NEW.vue?vue&type=script&lang=js"
export * from "./FORUM_CANDIDATE_VAL_NEW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__